import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { ErrorWithIcon } from '@ui/components/common/TextField/ErrorWithIcon';
import { Box } from '@mui/material';
import { REGISTRATION_FIELD_FILL_BG } from '../registrationFormFieldStyles';
import InfoIconTooltip from '@ui/components/common/Tooltips/InfoIconTooltip';
import { normalizeTrimmedValue } from '@ui/components/common/TextField/text-input-normalize';
const ETextField = ({ name, control, label, rules, error, multiline, rows, bgColor = REGISTRATION_FIELD_FILL_BG, fieldType, tooltipText, disabled, ...rest }) => {
    // Custom onChange handler for phone fields to filter invalid characters
    const handlePhoneChange = (e, field) => {
        if (fieldType === '3') {
            let value = e.target.value;
            // Only allow numbers, +, -, and spaces
            value = value.replace(/[^0-9+\-\s]/g, '');
            // If + is present, ensure it's only at the start
            if (value.includes('+')) {
                const plusIndex = value.indexOf('+');
                if (plusIndex > 0) {
                    // Remove + from middle/end and add it to start
                    value = '+' + value.replace(/\+/g, '');
                }
                // Ensure only one + at the start
                value = '+' + value.replace(/\+/g, '');
            }
            field.onChange(value);
            return;
        }
        const normalized = normalizeTrimmedValue(e.target.value, Boolean(multiline), 'change');
        if (normalized !== e.target.value) {
            field.onChange({
                ...e,
                target: { ...e.target, value: normalized },
                currentTarget: { ...e.currentTarget, value: normalized }
            });
            return;
        }
        field.onChange(e);
    };
    const handleBlur = (e, field) => {
        if (fieldType !== '3') {
            const normalized = normalizeTrimmedValue(e.target.value, Boolean(multiline), 'blur');
            if (normalized !== e.target.value) {
                field.onChange(normalized);
            }
        }
        field.onBlur();
    };
    const styledLabel = useMemo(() => !label ? undefined : (_jsxs(Box, { display: 'inline-flex', alignItems: 'center', gap: '4px', sx: { pointerEvents: 'auto' }, children: [label, tooltipText && (_jsx(Box, { sx: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    pointerEvents: 'auto',
                    cursor: 'pointer'
                }, children: _jsx(InfoIconTooltip, { title: tooltipText, size: 'small', variant: 'dark' }) }))] })), [label, tooltipText]);
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: ({ field, fieldState }) => (_jsxs(Box, { width: '100%', children: [_jsx(TextField, { ...field, label: styledLabel, error: !!error, variant: 'filled', disabled: disabled, sx: {
                        '.MuiInputBase-root.MuiFilledInput-root': {
                            backgroundColor: `${bgColor} !important`,
                            background: `${bgColor} !important`,
                            borderRadius: '12px !important',
                            overflow: 'hidden !important',
                            pr: 2
                        },
                        'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active': {
                            WebkitBoxShadow: `0 0 0 100px ${bgColor} inset !important`,
                            boxShadow: `0 0 0 100px ${bgColor} inset !important`,
                            WebkitTextFillColor: 'inherit !important',
                            caretColor: 'inherit !important',
                            transition: 'background-color 5000s ease-in-out 0s'
                        }
                    }, fullWidth: true, multiline: multiline, rows: rows, onChange: (e) => handlePhoneChange(e, field), onBlur: (e) => handleBlur(e, field), ...rest }), _jsx(ErrorWithIcon, { error: error, mt: 0.5, ml: 0.5 })] })) }));
};
export default ETextField;
